// extracted by mini-css-extract-plugin
module.exports = {"UserForm__avatar":"UserForm_UserForm__avatar__3ENYr","UserForm__actions":"UserForm_UserForm__actions__iNRUn","UserForm__actionButton":"UserForm_UserForm__actionButton__2Ak_3"};